const NEW_POSITION_HIGHLIGHT_KEY_PREFIX = "blancai:new-position-highlight";

const keyFor = (viewerId: string, positionId: number): string =>
  `${NEW_POSITION_HIGHLIGHT_KEY_PREFIX}:${viewerId}:${positionId}`;

export const highlightNewPosition = (
  viewerId: string,
  positionId: number,
): void => {
  try {
    window.localStorage.setItem(keyFor(viewerId, positionId), "true");
  } catch {
    return;
  }
};

export const dismissNewPositionHighlight = (
  viewerId: string,
  positionId: number,
): void => {
  try {
    window.localStorage.removeItem(keyFor(viewerId, positionId));
  } catch {
    return;
  }
};

export const isNewPositionHighlighted = (
  viewerId: string,
  positionId: number,
): boolean => {
  try {
    return window.localStorage.getItem(keyFor(viewerId, positionId)) !== null;
  } catch {
    return false;
  }
};
